import React, { Fragment, useEffect, useState } from "react";
import Slider from "react-slick";
import Container from "@/components/container/Container";
import CardComponent from "@/components/card";
import { Col, Flex, Form, Popover, Row, Select } from "antd";
import ButtonComponent from "@/components/button/Button";
import "@/styles/tasks/task-home.scss";
import IconAssignToYou from "@/components/icons/IconAssignToYou";
import SweetPopup from "@/components/modal/SweetPopup";
import BackWithLabel from "@/components/common/BackWithLabel";
import { getStudentTasks } from "@/services/students/getStudentTasks";
import IconDots from "@/components/icons/IconDots";
import { useNavigate } from "react-router-dom";
import { setCurrentForm, setFormProps, setModalOpen } from "@/reducers/commonSlice";
import { useDispatch } from "react-redux";
import { submitStudentTaskDocumentById } from "@/services/students/submitStudentTaskDocumentById";
import { getFormatedFileByCategory } from "@/services/users/getFormatedFileByCategory";
import { uploadFile } from "@/services/users/uploadFile";
import IconReport from "@/components/icons/IconReport";
import { createStudentTask, getGuideTasks } from "@/services/guides/getGuideTasks";
import IconAdd from "@/components/icons/IconAdd";
import IconTask from "@/components/icons/IconTask";
import dayjs from "dayjs";
import { createOwnTask } from "@/services/users/usersTask";
import { crateReport } from "@/services/users/getReportCategory";
import { markTaskAsCompleted } from "@/services/common/task";

const { Option } = Select;
const settings = {
  infinite: false,
  slidesToShow: 3,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 445,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const TaskHome = ({ isGuidePanel = false }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isSuccess, setIsSuccess] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [popupData, setPopupData] = useState({
    otherMessage: "You can check task on your task page.",
    message: "Task has been created successfully.",
    label: "View Task",
  });
  const [selectedPrimaryFilter, setSelectedPrimaryFilter] = useState("assign-to-you");
  const handleCreateTask = (isGuidePanel) => {
    if (isGuidePanel) {
      dispatch(setCurrentForm("createTask"));
      dispatch(setModalOpen(true));
      dispatch(
        setFormProps({
          onSubmit: (value, isOwnTask) => {
            let body = {};
            if (isOwnTask) {
              body = {
                title: value.title,
                description: value.description,
                deadline: value.deadline ? dayjs(value.deadline).format("YYYY-MM-DD") : null,
              };
              createOwnTask(body)
                .then((res) => {
                  console.log(res);
                  fetchData();
                  dispatch(setModalOpen(false));
                })
                .catch((error) => console.log(error));
            } else {
              body = {
                title: value.title,
                description: value.description,
                status: "todo",
                deadline: value.deadline ? dayjs(value.deadline).format("YYYY-MM-DD") : null,
                userId: value.students,
                productId: value.product,
              };
              createStudentTask(body)
                .then((res) => {
                  console.log(res);
                  fetchData();
                  dispatch(setModalOpen(false));
                })
                .catch((error) => console.log(error));
              console.log("form input data", value);
            }
            console.log("crete new task: ", body);
            dispatch(setModalOpen(false));
          },
          // initialValues: {
          //   taskName: "Task Title",
          //   description: "This is the description",
          //   dueDate: dayjs("2024-12-31"),
          // },
        })
      );
    } else {
      dispatch(setCurrentForm("createTask"));
      dispatch(setModalOpen(true));
      dispatch(
        setFormProps({
          onSubmit: (value, isOwnTask) => {
            let body = {};
            if (isOwnTask) {
              body = {
                title: value.title,
                description: value.description,
                deadline: value.deadline ? dayjs(value.deadline).format("YYYY-MM-DD") : null,
              };
            }
            console.log("crete new task: ", body);
            createOwnTask(body)
              .then((res) => {
                console.log(res);
                fetchData();
                dispatch(setModalOpen(false));
              })
              .catch((error) => console.log(error));
          },
          // initialValues: {
          //   title: "Task Title",
          //   description: "This is the description",
          //   deadline: dayjs("2024-12-31"),
          // },
          isOwnTask: true,
        })
      );
    }
  };

  function transformData(inputArray) {
    const groupedData = inputArray.reduce((acc, item) => {
      const guideName = item.assignedBy;
      if (!guideName) return acc;
      if (!acc[guideName?.id]) {
        acc[guideName?.id] = {
          guideName: guideName.fullName,
          profile: guideName.profileImgUrl ?? "/assets/images/task-guide-profile.png",
          tasks: [],
        };
      }

      const deadlineDate = item.deadline ? new Date(item.deadline) : null;
      const isOverdue = deadlineDate && deadlineDate < new Date();

      acc[guideName?.id]?.tasks.push({
        ...item,
        id: item.id,
        progress: item.closedAt
          ? "Completed"
          : item.completedAt
            ? "Submitted"
            : isOverdue
              ? "Overdue"
              : "To Do",
        value: item.closedAt
          ? "Completed"
          : item.completedAt
            ? "Submitted"
            : isOverdue
              ? "Overdue"
              : "To Do",
        title: item.title,
        description: item.description,
        taskId: item.taskId,
        ownerId: item.ownerId,
        totalLimit: item.totalLimit,
        currentLimit: item.currentLimit,
        deadline: deadlineDate
          ? deadlineDate.toLocaleDateString("en-GB", {
              weekday: "long",
              day: "numeric",
              month: "short",
            })
          : "No deadline",
        closedAt: item.closedAt,
        assignedById: item.assignedBy.id,
        userId: item.userId,
        status: item.status,
      });

      return acc;
    }, {});

    return Object.values(groupedData);
  }

  function transformGroupedData(inputArray) {
    return inputArray.map((guideData) => ({
      studentName: guideData.name,
      profile:
        guideData.profileImgUrl && guideData.profileImgUrl.trim() !== ""
          ? guideData.profileImgUrl
          : "/assets/images/task-guide-profile.png",
      tasks: guideData.tasks.map((task) => {
        const deadlineDate = task.deadline ? new Date(task.deadline) : null;
        const isOverdue = deadlineDate && deadlineDate < new Date();

        return {
          ...task,
          id: task.id,
          progress: task.closedAt
            ? "Completed"
            : task.completedAt
              ? "Submitted"
              : isOverdue
                ? "Overdue"
                : "To Do",
          value: task.closedAt
            ? "Completed"
            : task.completedAt
              ? "Submitted"
              : isOverdue
                ? "Overdue"
                : "To Do",
          title: task.title,
          description: task.description,
          taskId: task.taskId,
          ownerId: task.ownerId,
          closedAt: task.closedAt,
          totalLimit: task.totalLimit ?? 0, // Added fallback for missing fields
          currentLimit: task.currentLimit ?? 0, // Added fallback for missing fields
          deadline: deadlineDate
            ? deadlineDate.toLocaleDateString("en-GB", {
                weekday: "long",
                day: "numeric",
                month: "short",
              })
            : "No deadline",
          assignedById: task.assignedBy,
          userId: task.userId,
          status: task.status,
        };
      }),
    }));
  }
  const fetchData = async () => {
    const fileData = await getFormatedFileByCategory();
    if (isGuidePanel) {
      try {
        const res = await getGuideTasks();
        const output = transformGroupedData(Object.values(res), fileData);
        console.log("guideTasks:", fileData, output);

        setTasks(Array.isArray(output) ? output : [output]);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const res = await getStudentTasks();
        // const taskIds = res?.map((x) => x.taskId);
        // const taskResponse = await getTaskById(taskIds);

        const updatedTask = res.map((x) => {
          const matchedFile = fileData?.find((y) => y.id === x.fileCategoryId);
          return {
            ...x,
            totalLimit: matchedFile?.limit,
            currentLimit: matchedFile?.limit - matchedFile?.files?.length,
          };
        });
        // const taskArray = res?.map((x) => {
        //   let cloneData = { ...x }; // Clone the data
        //   cloneData.taskId = updatedTask.find((t) => t.id === cloneData.taskId);
        //   return cloneData;
        // });

        const output = transformData(updatedTask, fileData);
        console.log("studentTasks", output);
        setTasks(output);
      } catch (error) {
        console.log(error);
      }
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleStudentSubmit = (item) => {
    const id = item.id;
    const limit = item.limit;
    console.log(limit);
    if (isOwnTask(item)) {
      markTaskAsComplete(id);
    } else if (item.progress !== "Submitted") {
      dispatch(setCurrentForm("dashboardDocChat"));
      dispatch(setModalOpen(true));
      dispatch(
        setFormProps({
          onSubmit: async (value) => {
            const files = [];
            let body = {};
            if (value?.file?.fileList?.length > 0) {
              const uploadPromises = value.file?.fileList?.map(async (fileItem) => {
                const formData = new FormData();
                formData.append("file", fileItem.originFileObj);

                return uploadFile(-1, formData)
                  .then((res) => {
                    files.push(res);
                  })
                  .catch((err) => {
                    console.error(err);
                  });
              });

              await Promise.all(uploadPromises);
              body = {
                comment: value.comment ?? "",
                files: files,
              };
            } else {
              console.log("No files to upload");
              body = {
                comment: value.comment ?? "",
              };
            }
            if (isOwnTask(item)) {
            }
            submitStudentTaskDocumentById(id, body)
              .then((res) => {
                fetchData();
                dispatch(setModalOpen(false));
              })
              .catch((err) => console.log(err));

            // const file = value.file.fileList[0]?.originFileObj;
            // const comment = value.comment;
            // const formData = new FormData();
            // formData.append("file", file);
            // formData.append("comment", comment);
            // submitStudentTaskDocumentById(id, formData)
            //   .then((res) => {
            //     dispatch(setModalOpen(false));
            //     fetchData();
            //   })
            //   .catch((error) => console.log(error));
          },
          limit: limit,
          isComment: !item.fileCategoryId,
        })
      );
    }
  };
  const markTaskAsComplete = (id) => {
    dispatch(setCurrentForm("confirmDelete"));
    dispatch(setModalOpen(true));
    dispatch(
      setFormProps({
        message: "Mark this task as completed?",
        onSubmit: () => {
          markTaskAsCompleted(id).then((res) => {
            dispatch(setModalOpen(false));
            fetchData();
          });
        },
      })
    );
  };

  const handleGuideSubmit = (item) => {
    const id = item.id;
    const limit = item.limit;
    console.log(limit);
    if (item.progress === "Submitted" || isOwnTask(item)) {
      markTaskAsComplete(id);
    } else {
      handleStudentSubmit(item);
    }
  };
  const isButtonDisabled = (item, isGuidePanel) => {
    if (isGuidePanel) {
      if (isOwnTask(item)) {
        if (item.status !== "todo") {
          return true;
        }
      } else if (!item.completedAt || item.closedAt) {
        return true;
      }
    } else {
      if (item.status !== "todo") {
        return true;
      }
    }
    return false;
  };
  const getTaskLabel = (item) => {
    if (isOwnTask(item)) {
      return item.status === "todo" ? "Complete Task" : "Completed";
    }

    if (isGuidePanel) {
      return item.status === "completed" ? "Completed" : "Mark as Completed";
    }

    return item.status === "todo" ? "Submit Task" : "Submitted";
  };
  const handleChangeCategory = (value) => {
    setSelectedCategory(value);
  };

  const handleFilterChange = (value) => {
    setSelectedPrimaryFilter(value);
  };
  const isOwnTask = (item) => {
    return item.userId === item.assignedById;
  };
  const handleFilteredData = () => {
    const cloneData = JSON.parse(JSON.stringify(tasks));
    const updatedData = cloneData.map((x) => {
      const cloneItem = JSON.parse(JSON.stringify(x));
      let filteredTasks = cloneItem.tasks.filter((task) => {
        const categoryMatch = selectedCategory === "All" || task.value === selectedCategory;
        if (selectedPrimaryFilter === "my-task") {
          return categoryMatch && isOwnTask(task);
        }
        return categoryMatch;
      });

      return {
        ...cloneItem,
        tasks: filteredTasks,
      };
    });

    setFilteredTasks([...updatedData.filter((x) => x.tasks.length > 0)]);
  };
  const onReportClick = (taskId) => {
    dispatch(setCurrentForm("report"));
    dispatch(
      setFormProps({
        categoryType: "Task",
        handleSubmit: (data) => {
          if (data.categoryId && data.description) {
            data.metadata = { taskId };
            crateReport(data).then((res) => {
              console.log(res);
              dispatch(setModalOpen(false));
              dispatch(setCurrentForm("successModal"));
              dispatch(setModalOpen(true));
              dispatch(
                setFormProps({
                  message: "Your report has been submitted successfully.",
                  btnLabel: "Close",
                  onSubmit: () => {
                    dispatch(setModalOpen(false));
                  },
                })
              );
            });
          }
        },
      })
    );
    dispatch(setModalOpen(true));
  };

  useEffect(() => {
    handleFilteredData();
  }, [selectedCategory, tasks, selectedPrimaryFilter]);

  const TaskCard = ({ item, index }) => {
    return (
      <Col sm={24} xs={24} key={item.id} className="carousel-item">
        <CardComponent>
          <div className="task">
            <div className="task-content">
              <Flex className="task-number body-b4" align="center" justify="space-between">
                <div>{item.title}</div>
                <Popover
                  placement="bottomRight"
                  content={content({
                    id: item.id,
                  })}
                  // open={openId === index}
                  trigger="hover"
                  onClick={(e) => e.stopPropagation()}
                >
                  <IconDots className="cursor-pointer" on />
                </Popover>
              </Flex>
              <div
                className="task-content"
                onClick={() => navigate(`/dashboard/comments/${item.id}`)}
              >
                {item.progress === "Overdue" ? (
                  <div className="progress-red">{item.progress}</div>
                ) : (
                  <div className="progress">{item.progress}</div>
                )}
                <div className="task-name body-b1-2">{item.description}</div>
                <div className="deadline body-b4">
                  Deadline: <span>{item.deadline}</span>
                </div>
              </div>
              <div className="submit-button">
                <ButtonComponent
                  label={getTaskLabel(item)}
                  disabled={isButtonDisabled(item, isGuidePanel)}
                  varient="success"
                  onClick={() =>
                    isGuidePanel ? handleGuideSubmit(item) : handleStudentSubmit(item)
                  }
                />
              </div>
            </div>
          </div>
        </CardComponent>
      </Col>
    );
  };

  const content = ({ id }) => {
    return (
      <div className="menulink-popover">
        <Flex
          align="center"
          gap="0.5rem"
          className="color-brand cursor-pointer"
          onClick={() => {
            // dispatch(setModalOpen(true))
          }}
        >
          <IconReport />
          <span onClick={() => onReportClick(id)}>Report</span>
        </Flex>
      </div>
    );
  };

  return (
    <Fragment>
      <div className="task-wrapper">
        <Container>
          <div className="heading">
            <BackWithLabel path="/dashboard" label="Task" />
          </div>

          <div className="task-card">
            <CardComponent>
              <div className="header">
                <Row>
                  <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Row gutter={[16, 16]}>
                      <Col xxl={8} xl={8} lg={14} md={24} sm={24} xs={24}>
                        <Form.Item name="assign-menu">
                          <Select
                            virtual={false}
                            showSearch
                            className="w-100"
                            placeholder="Select Type"
                            defaultValue={selectedPrimaryFilter}
                            onChange={(value) => handleFilterChange(value)}
                          >
                            <Option className="assign-menu" value="assign-to-you">
                              <IconAssignToYou /> Assigned to you
                            </Option>
                            <Option className="assign-menu" value="my-task">
                              <IconTask /> My Task
                            </Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xxl={6} xl={6} lg={10} md={24} sm={24} xs={24}>
                        <Form.Item name="category">
                          <Select
                            virtual={false}
                            showSearch
                            className="w-100"
                            placeholder="Select Category"
                            onChange={(value) => handleChangeCategory(value)}
                            defaultValue={selectedCategory}
                          >
                            <Option className="category-menu" value="All">
                              All
                            </Option>
                            <Option className="category-menu" value="To Do">
                              To Do
                            </Option>
                            <Option className="category-menu" value="Submitted">
                              Submitted
                            </Option>
                            <Option className="category-menu" value="Completed">
                              Completed
                            </Option>
                            <Option className="category-menu" value="Overdue">
                              Overdue
                            </Option>
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <div className="add-task">
                      <ButtonComponent
                        varient="primary"
                        label="Add New Task"
                        iconRight={false}
                        onClick={() => handleCreateTask(isGuidePanel)}
                      >
                        <IconAdd
                          width="24px"
                          height="24px"
                          color="#db5800"
                          style={{
                            border: "1px solid #fdfefe",
                            backgroundColor: "#fdfefe",
                            borderRadius: "4px",
                          }}
                        />
                      </ButtonComponent>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="content">
                <Row gutter={[24, 16]}>
                  {filteredTasks.length ? (
                    filteredTasks?.map((item, index) => {
                      return (
                        <Fragment key={"fag" + index}>
                          <Col
                            xxl={3}
                            xl={3}
                            lg={6}
                            md={24}
                            sm={24}
                            xs={24}
                            // key={item.guideName.id + "task" + index}
                          >
                            <div className="info">
                              <CardComponent>
                                <div className="profile-picture">
                                  <img src={item.profile} alt="profile-picture" />
                                </div>
                                <div className="profile-name">
                                  <div className="name body-b1">
                                    {item.guideName || item.studentName}
                                  </div>
                                </div>
                              </CardComponent>
                            </div>
                          </Col>
                          <Col xxl={21} xl={21} lg={18} md={24} sm={24} xs={24}>
                            <div className="w-100 tasks">
                              {item.tasks?.length ? (
                                <Slider {...settings}>
                                  {item.tasks.map((item, index) => {
                                    return <TaskCard key={item.id} item={item} index={index} />;
                                  })}
                                </Slider>
                              ) : (
                                <></>
                              )}
                              {/* <Carousel
                              arrows
                              infinite={false}
                              slidesToShow={
                                window.innerWidth <= 425
                                  ? 1
                                  : window.innerWidth <= 768
                                  ? 2
                                  : 3
                              }
                              dots={false}
                            >
                              {item.tasks.map((item, index) => {
                                return (
                                  <TaskCard
                                    key={item.id}
                                    item={item}
                                    index={index}
                                  />
                                );
                              })}
                            </Carousel> */}
                            </div>
                          </Col>
                        </Fragment>
                      );
                    })
                  ) : (
                    <div className="task no-task" style={{ height: "100%", width: "100%" }}>
                      <div
                        className="session-outer-card"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          margin: "auto 0",
                        }}
                      >
                        <img src="/assets/images/availbility.png" />
                        <div className="title-h4">No tasks Available</div>
                      </div>
                    </div>
                  )}
                </Row>
              </div>
            </CardComponent>
          </div>

          <SweetPopup
            isOpen={isSuccess}
            isDone={true}
            otherMessage={popupData.otherMessage}
            message={popupData.message}
          >
            <div className="success-button">
              <ButtonComponent
                varient="primary"
                label={popupData.label}
                onClick={() => setIsSuccess(false)}
              />
            </div>
          </SweetPopup>
        </Container>
      </div>
    </Fragment>
  );
};

export default TaskHome;
